import React, { useEffect, useLayoutEffect, useState } from 'react'
import PublicKeyVisual from '../../components/layout/PublicKeyVisual';
import { Footer } from '../../components/layout/Footer';
import { Documents } from '../../components/layout/Documents';
import bgCtBottom from "../../assets/images/layout/bg-ct-bottom.svg";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { checkDpSuccess, handleSessionClear } from '../../utility/service/tool-service';
import { initDataProp } from '../../utility/service/api-service';
import AiLexiHelper from '../../components/AiLexiHelper';
import { getSupportedLanguage } from '../../utility/languageUtils';
/**
 * mainBgPos 大圖主要位置
 * pageTitle 標題文字
 * isMember 是否已是會員 決定點下底下按鈕要去哪頁(register or login)
 * **/
const LoginCommonOutline = ({children,mainBgPos="main-left",pageTitle="",isMember=false,isInvite=false}) => {
  const navigate = useNavigate();//導頁
  const { t } = useTranslation();
  const [showAi,setShowAi] = useState(true);
  let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';

  // const axios_initDataProp = ()=>{
  //   initDataProp({reqType:'aiChat'})
  //     .then((res)=>{
  //       if(checkDpSuccess(res)){
  //         let data = res?.data?.RespBody;
  //         let aiChat = data.aiChat==='N'?false:true;
  //         setShowAi(aiChat)
  //       }
        
  //     })
  // }

  useEffect(()=>{
    // axios_initDataProp();
  },[])


  return (
    <div className={`layout-public-model ${mainBgPos} ${getSupportedLanguage()} ${themeColorSession}`}>
       <div className='layout-kv-panel' >
        <PublicKeyVisual isMember={isMember} onClick={()=>{
          if(isMember===false && sessionStorage?.getItem("loadTheme")==='mint'){ //管理者要按註冊按鈕 返回不跳頁
            return
          }else{
            isMember?navigate('/login'):navigate('/register/JDBC'); handleSessionClear(isInvite);
          }
         
          }}  text={isMember?t('click_log_in'):t('join_us')}/>
      </div>
      <div className="layout-main-content">
        <div className="main-form">
          <h1 className="text-start" dangerouslySetInnerHTML={{ __html: pageTitle}}></h1>
          {/* 替換區 給Login Register 和 忘記密碼頁使用 */}
          {children}
        </div>
        <img className="layout-main-content-bg" src={bgCtBottom}/>
        {/* <Documents></Documents> */}
        {/* {
            showAi && <AiLexiHelper />
          } */}
        <Footer isPublic={true}></Footer>
      </div>
    </div>
  )
}

export default LoginCommonOutline;